import { useEffect, useState } from "react";
import api from "@/lib/api";


const useSiteSettings = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    let active = true;
    api.get("/settings")
      .then((response) => {
        if (active) setSettings(response.data);
      })
      .catch(() => {
        if (active) setSettings(null);
      });
    return () => {
      active = false;
    };
  }, []);

  return settings;
};

export default useSiteSettings;
